import { render } from "./gaji-history-custom.vue?vue&type=template&id=0249ef13"
import script from "./gaji-history-custom.vue?vue&type=script&lang=js"
export * from "./gaji-history-custom.vue?vue&type=script&lang=js"

import "./gaji-history-custom.vue?vue&type=style&index=0&id=0249ef13&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__